module.exports = __webpack_public_path__ + "ic-member-profile.svg?99c3106ed6ec45161c4f5fb53c67e612";